import {Injectable} from '@angular/core';
import {BoAutocompleteOption} from '../model/BoAutocompleteOption';
import {DynamicFormControl} from './DynamicFormControl';
import {BoInstanceAmountToSave} from '../model/BoInstanceAmountToSave';
import {BoInstanceToSave} from '../model/BoInstanceToSave';
import {BoiDialogData} from '../model/BoiDialogData';

@Injectable()
export class DynamicFormInnerService {
  dynamicFormControl: DynamicFormControl;

  changeValue(fieldId: string, value: string) {
    this.dynamicFormControl.changeValue(fieldId, value);
  }

  autocompleteClick(option: BoAutocompleteOption) {
    this.dynamicFormControl.autocompleteClick(option);
  }

  reduceValidStatus() {
    this.dynamicFormControl.reduceValidStatus();
  }

  saveBoiAmount(amountToSave: BoInstanceAmountToSave) {
    this.dynamicFormControl.saveBoiAmount(amountToSave);
  }

  saveBoInstance(toSave: BoInstanceToSave) {
    this.dynamicFormControl.saveBoInstance(toSave);
  }

  openBioDialog(data: BoiDialogData) {
    this.dynamicFormControl.openBoiDialog(data);
  }

  get needAutocomplete() {
    return this.dynamicFormControl.config.needAutocomplete;
  }

  get boiDraftId(): string {
    return this.dynamicFormControl.config.boiDraftId;
  }

  get ownerData() {
    return this.dynamicFormControl.config.ownerData;
  }

  get autocompleteClicked() {
    return this.dynamicFormControl.autocompleteClicked;
  }

  get isValid() {
    return this.dynamicFormControl.isValid;
  }
}
